import React, { useState, useEffect } from "react";
import TitleBar from "./TitleBar";
import Accordion from "./accordion/Accordion";
import { getFAQs } from "../contentful";
import { Helmet } from "react-helmet";

const iconStyle = {
  color: "rgb(139, 9, 9)",
};

const Contact = () => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    getFAQs().then((data) => setFaqs(data));
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact the Lucille Graham Trust</title>
        <meta
          name="description"
          content="Contact the Lucille Graham Trust about applying for grants for musical projects in London."
        />
        <link
          rel="canonical"
          href="https://www.lucillegrahamtrust.org.uk/contact"
        />
      </Helmet>
      <TitleBar title='Contact & FAQs' />
      <div className='content'>
        <div className='contact'>
          <p>Please contact the Lucille Graham Trust via email at:</p>
          <p>
            <a href='mailto: lucillegtrust@gmail.com'>lucillegtrust@gmail.com</a>
          </p>
          <hr />

          <h3 style={{ borderBottom: "1px solid gray", padding: "3px" }}>FAQs</h3>
          {faqs.map((item) => (
            <div className='accordion-wrapper'>
              <Accordion title={item.fields.question} content={item.fields.answer} />
            </div>
          ))}

          {/* <div className="social"> */}
          {/* <a style={iconStyle} href="https://www.linkedin.com/in/alexandra-stacey-538602b/"><FaLinkedin size={30}/></a>

   <a style={iconStyle} href="https://twitter.com/RuddyRaven"><FaTwitter size={30}/></a> */}
          {/* </div> */}
        </div>
      </div>
    </>
  );
};

export default Contact;
